module.exports = __webpack_public_path__ + "static/media/calendar.6793d775.svg";